// extracted by mini-css-extract-plugin
export default {"widthComboBox":"CommonVariables_widthComboBox__jki8o","widthTextBox":"CommonVariables_widthTextBox__Q-7Bq"};